import React from 'react';

function Social({ size, strokeWidth, stroke, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 36 36"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path
        d="M18 25.875C20.1746 25.875 21.9375 24.1121 21.9375 21.9375C21.9375 19.7629 20.1746 18 18 18C15.8254 18 14.0625 19.7629 14.0625 21.9375C14.0625 24.1121 15.8254 25.875 18 25.875Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M18 25.875C16.2143 25.8897 14.506 26.6056 13.2433 27.8683C11.9806 29.131 11.2647 30.8393 11.25 32.625V33.75H24.75V32.625C24.7353 30.8393 24.0194 29.131 22.7567 27.8683C21.494 26.6056 19.7857 25.8897 18 25.875Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M29.25 9C31.114 9 32.625 7.48896 32.625 5.625C32.625 3.76104 31.114 2.25 29.25 2.25C27.386 2.25 25.875 3.76104 25.875 5.625C25.875 7.48896 27.386 9 29.25 9Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M34.875 15.75C34.875 11.5312 32.3438 9 29.25 9C26.1562 9 23.625 11.5312 23.625 15.75H34.875Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M6.75 9C8.61396 9 10.125 7.48896 10.125 5.625C10.125 3.76104 8.61396 2.25 6.75 2.25C4.88604 2.25 3.375 3.76104 3.375 5.625C3.375 7.48896 4.88604 9 6.75 9Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M12.375 15.75C12.375 11.5312 9.84375 9 6.75 9C3.65625 9 1.125 11.5312 1.125 15.75H12.375Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M13.5 7.875H22.5M6.75 19.125L11.25 23.625L6.75 19.125ZM29.25 19.125L24.75 23.625L29.25 19.125Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Social;
